import { shouldShowTradeLogin, initTradeLogin } from '../../helpers/isLoggedOutTradeHelper';

/*
 * This notification serves to block other notifications from running and potentially launching
 * a modal when the trade specific login modal is launched from DBL's initialize method.
 */
export default {
    name: 'loggedOutTrade',
    rule: () => Promise.resolve(shouldShowTradeLogin()),
    action: () => dispatch => {
        initTradeLogin();
        dispatch({ type: 'noop' });
    },
    priority: 500,
};
